import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7d5a8da8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "row kometa-clenky mb-4",
  ref: "kometa-clenky"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "h3 w-100" }, "Členky týmu", -1))
const _hoisted_3 = { class: "row row-cols-1 row-cols-md-2 row-cols-lg-4 gx-5" }
const _hoisted_4 = { class: "card border-0 h-100" }
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = { class: "card-body" }
const _hoisted_7 = { class: "card-title text-center" }
const _hoisted_8 = { class: "card-subtitle text-center" }
const _hoisted_9 = { class: "card-text text-center" }
const _hoisted_10 = { class: "d-flex flex-row justify-content-center align-items-center" }
const _hoisted_11 = { class: "kometa-clenky-navigace d-flex flex-row align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_skater = _resolveComponent("skater")!
  const _component_icon = _resolveComponent("icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_TransitionGroup, { name: "members" }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.membersCards, (member, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "col",
              key: index
            }, [
              _createElementVNode("div", _hoisted_4, [
                (member.obrazek)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: member.obrazek,
                      alt: member.jmeno,
                      class: "card-img-top kometa-image-rounded"
                    }, null, 8, _hoisted_5))
                  : (_openBlock(), _createBlock(_component_skater, {
                      key: 1,
                      class: "card-img-top kometa-image-rounded h-kometa-member",
                      color: _ctx.color
                    }, null, 8, ["color"])),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("h5", _hoisted_7, _toDisplayString(member.jmeno), 1),
                  _createElementVNode("p", _hoisted_8, " V Kometě od r. " + _toDisplayString(member.od), 1),
                  _createElementVNode("p", _hoisted_9, _toDisplayString(member.popis), 1)
                ])
              ])
            ]))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_icon, {
          onClick: _withModifiers(_ctx.goPrev, ["prevent"]),
          type: "fas",
          "icon-name": "arrow-left",
          height: 20
        }, null, 8, ["onClick"]),
        _createVNode(_component_icon, {
          onClick: _withModifiers(_ctx.goNext, ["prevent"]),
          type: "fas",
          "icon-name": "arrow-right",
          height: 20
        }, null, 8, ["onClick"])
      ])
    ])
  ], 512))
}